export const PagesTypes = {
    WL_FETCH_PAGES: 'WL_FETCH_PAGES',
    WL_SET_PAGES:'WL_SET_PAGES'
}